module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "primary-header"
  }, [_c('h1', {
    attrs: {
      "data-qa": "Content-Notifications-Title"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.componentTitle) + "\n      "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), (!_vm.noQuotaBlockShows) ? _c('div', {
    staticClass: "create-new-block"
  }, [_c('span', {
    staticClass: "limitation",
    class: {
      alert: _vm.isRulesLimitReached
    },
    attrs: {
      "data-qa": "Content-LimitationNotifacations-Text"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('notificationsLimitationText', {
    ownRules: _vm.ownRules,
    limitRules: _vm.limitRules
  })) + "\n      ")]), _vm._v(" "), (_vm.canAddNotification) ? _c('el-button', {
    attrs: {
      "data-qa": "Content-AddNotification-Button",
      "id": "btn-notification-form",
      "type": "warning"
    },
    on: {
      "click": _vm.showAddNotification
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('notificationsButtonAddNotificationText')) + "\n      ")]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), (!_vm.noQuotaBlockShows) ? _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "notifications-table",
    attrs: {
      "data": _vm.notificationsList,
      "default-sort": _vm.defaultSort,
      "element-loading-text": _vm.$t('notificationsTableLoadingText'),
      "empty-text": _vm.$t('notificationsTableEmptyText'),
      "data-qa": "Content-Notifications-Table",
      "element-loading-background": "#FFFFFF",
      "fit": "",
      "header-row-class-name": "notifications-table__header",
      "max-height": "100%",
      "show-header": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColRuleLabel'),
      "prop": "rule",
      "sortable": "",
      "min-width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColInfoModelLabel'),
      "sortable": "",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "word-break"
        }, [_vm._v(_vm._s(props.row.familyNames))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColTitleLabel'),
      "min-width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "word-break"
        }, [_vm._v(_vm._s(props.row.title))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('notificationsTableColMessageLabel'),
      "min-width": "240"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "word-break"
        }, [_vm._v(_vm._s(props.row.message))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "",
      "fixed": "right",
      "min-width": "60"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": _vm.$t('notificationsTooltipEditText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": ("Content-EditNotification-Button-" + (scope.row.title)),
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.editNotification(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil operation-icons"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": _vm.$t('notificationsTooltipDeleteText'),
            "effect": "dark",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "data-qa": ("Content-DeleteNotification-Button-" + (scope.row.title)),
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.delNotification(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash operation-icons"
        })])], 1)]
      }
    }])
  })], 1) : _c('div', {
    staticClass: "notify-limited-block",
    attrs: {
      "data-qa": "Content-LimitedBlockNotifications-Text"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('NotificationsLimitedBlockNotificationsTitle')) + "\n    ")]), _vm._v(" "), _c('i18n', {
    attrs: {
      "path": "NotificationsLimitedBlockNotificationsBody",
      "tag": "p"
    }
  }, [_c('br', {
    attrs: {
      "place": "br"
    }
  }), _vm._v(" "), _c('p', {
    attrs: {
      "place": "p"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:support@exosite.com",
      "place": "support"
    }
  }, [_vm._v(_vm._s(_vm.$t('solutionStatusTestDialogSupport')))])])], 1), _vm._v(" "), _c('notifications-edit', {
    attrs: {
      "familyMembers": _vm.familyMembers,
      "familyNames": _vm.familyNames,
      "uid": _vm.uid
    }
  }), _vm._v(" "), _c('notifications-delete'), _vm._v(" "), _c('notifications-create', {
    attrs: {
      "familyMembers": _vm.familyMembers,
      "familyNames": _vm.familyNames,
      "noQuota": _vm.isRulesLimitReached,
      "uid": _vm.uid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41e58ac8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/Notifications.vue
// module id = 965
// module chunks = 3